import { isBefore } from 'date-fns'

import type { Appointment } from '../types/appointment.types'

/**
 * Whether the detail screen offers the "call me if something comes free" switch.
 *
 * It shows when the agenda offers a waitlist, and also when the patient is already on one: the
 * hospital can withdraw eligibility afterwards and the api still allows leaving, so hiding it would
 * strand the patient on a list they cannot leave. A cancelled appointment has nothing to bring
 * forward. The cut-off is the exact start, not the day: once the start has passed there is no
 * earlier slot to offer, even later that same day.
 */
function canShowWaitlist(appointment: Appointment, now: Date = new Date()): boolean {
  const hasWaitlist = appointment.meta?.waitlistEligible === true || appointment.meta?.waitlisted === true

  if (!hasWaitlist || appointment.status === 'cancelled') {
    return false
  }

  return isBefore(now, new Date(appointment.start))
}

export { canShowWaitlist }
